import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useToasts } from "react-toast-notifications";
import { useMutation } from "../../../GraphQL/helpers";
import { Row, Column } from "../../global/grid";
import Button from "../../global/button";
import Modal, { ModalBody, ModalFooter } from "../../global/modal";
import Alert from "../../global/alert";
import SpiMasked from "../../global/spiMasked";
import GET_PROFILE from "../../../GraphQL/queries/fetchProfile";
import { DELETE_PHONE } from "../../../GraphQL/mutations/phone";
import errorHandler from "../../../utilities/errorHandler";

const DeletePhoneModal = ({
    phone,
    onClose,
    innerRef,
    ...attributes
}) => {
    const { t } = useTranslation("components.profile.deletePhoneModal");
    const { addToast } = useToasts();
    const [deletePhone, { loading: deleteLoading }] = useMutation(DELETE_PHONE);
    const [modalError, setModalError] = useState(null);
    let modalRef = useRef(null);
    if (innerRef) {
        modalRef = innerRef;
    }

    const onCloseHandler = () => {
        setModalError(null);
        onClose && onClose();
    };

    const onSubmit = async () => {
        try {
            const { data: resultData } = await deletePhone({
                variables: { id: phone.id },
                optimisticResponse: {
                    eliminarTelefono: {
                        telefono: {
                            id: phone.id,
                            __typename: "Telefono",
                        },
                        errores: null,
                    }
                },
                update(cache, { data: { eliminarTelefono } }) {
                    const { perfil } = cache.readQuery({ query: GET_PROFILE });

                    if (eliminarTelefono?.telefono) {
                        cache.writeQuery({
                            query: GET_PROFILE,
                            data: {
                                perfil: {
                                    ...perfil,
                                    telefonos: perfil.telefonos.filter(t => t.id !== eliminarTelefono.telefono.id),
                                }
                            },
                        });
                    }
                },
            });
            const { errores } = resultData.eliminarTelefono;

            if (errores) {
                setModalError({
                    title: t("errors.delete.default.title"),
                    message: errores[0].mensaje,
                });
            } else {
                addToast((
                    <div>
                        <div>
                            <strong>{t("deleteConfirm")}</strong>
                        </div>
                        <div>
                            <SpiMasked type="phone">{phone.numero}</SpiMasked>
                        </div>
                    </div>
                ), {
                    appearance: "success",
                });
                modalRef?.current && modalRef.current.close();
            }
        } catch (error) {
            errorHandler(error, () => {
                setModalError(t("errors.delete.default", { returnObjects: true }));
            });
        }
    };

    return (
        <Modal
            {...attributes}
            title={t("title")}
            onClose={onCloseHandler}
            ref={modalRef}
        >
            <ModalBody>
                {modalError && (
                    <Row>
                        <Column sm="12">
                            <Alert variant="danger" {...modalError}/>
                        </Column>
                    </Row>
                )}

                <Row>
                    <Column sm="12" textAlign="center">
                        <strong>
                            <SpiMasked type="phone">{phone.numero}</SpiMasked>
                        </strong>
                    </Column>
                </Row>

                <Row mt={5}>
                    <Column sm="12" textAlign="center">
                        <p>{t("prompt")}</p>
                    </Column>
                </Row>
            </ModalBody>

            <ModalFooter>
                {/*<Button type="button" block size="md" colors="light" onClick={() => toggleModal(false)}>{t("close")}</Button>*/}
                <Button type="button" block size="lg" colors="primaryWithBg" onClick={onSubmit} disabled={deleteLoading} loading={deleteLoading}>{t("submit")}</Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeletePhoneModal;
